module.exports = __webpack_public_path__ + "img/output_page_preview_bg.png";